export default "__VITE_ASSET__DaxJwHC8__"